<template>
    <div class="flex border-t border-b -my-px mb-0 border-gray-200 draggable bg-white">
        <!-- Draggable handle. -->
        <div class="w-6 self-start py-1.5">
            <div class="w-5 h-5 flex items-center">
                <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move handle"
                   v-if="!readonly"></i>
            </div>
        </div>
        <!-- Material. -->
        <div class="flex-1 flex -ml-px">
            <page-cell
                ref="material"
                :read-only="readonly"
                class="text-sm -my-px px-2 py-1.5 border-l border-gray-200"
                :placeholder="'Material...'"
                v-model="name"
                @input="fixAll"
            ></page-cell>
        </div>
        <!-- UoM. -->
        <div class="w-24 flex -ml-px">
            <page-cell
                ref="uom"
                :read-only="readonly"
                class="text-sm -my-px px-2 py-1.5 border-l border-gray-200"
                :placeholder="'UoM...'"
                v-model="uom"
                @input="fixAll"
            ></page-cell>
        </div>
        <!-- Unfixed -->
        <div class="w-24 flex -ml-px">
            <page-cell
                ref="qty"
                :read-only="readonly"
                class="text-sm -my-px px-2 py-1.5 border-l border-gray-200"
                :placeholder="'Qty...'"
                v-model="qty"
                @input="updateQty"
                @change="fixAll"
            ></page-cell>
        </div>
        <!-- Rate -->
        <div class="w-24 flex -ml-px">
            <page-cell
                ref="rate"
                :currency="true"
                :read-only="readonly"
                class="text-sm -my-px px-2 py-1.5 border-l border-gray-200 text-right"
                :placeholder="'£...'"
                v-model="rate"
                @input="updateRate"
                @change="fixAll"
            ></page-cell>
        </div>
        <!-- Total -->
        <div class="w-28 flex -ml-px">
            <page-cell
                ref="total"
                :currency="true"
                :read-only="readonly"
                class="text-sm -my-px px-2 py-1.5 border-l border-r border-gray-200 text-right"
                :placeholder="'£...'"
                v-model="total"
                @input="updateTotal"
                @change="fixAll"
            ></page-cell>
        </div>
        <!-- Dropdown. -->
        <div class="w-8 flex-shrink-0 m-0 self-start pt-2">
            <ui-dropdown menu-class="px-2 py-2 w-64" v-if="(!readonly)">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="ml-2 w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                        <i class="fa fa-ellipsis-h fa-fw"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <ui-dropdown-item icon="fas fa-trash" danger @click="$emit('removeMaterial',material);close()">
                        Delete Material
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>

import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import {toCurrency, resolveNumericText} from "../../../utils";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {debounce} from "lodash";
import * as math from 'mathjs';

export default {
    components: {
        UiButtonNew, UiDropdown, UiDropdownItem, UiDropdownDivider
    },
    props: {
        material: Object,
        readonly: false,
    },
    data() {
        return {
            rate: this.material.rate,
            total: this.material.total,
            qty: this.material.qty,
            name: this.material.name,
            uom: this.material.uom,
        }
    },
    computed: {},
    methods: {
        updateRate() {
            let rate = math.round(resolveNumericText(this.rate), 2)
            let qty = math.round(resolveNumericText(this.qty), 3)
            this.total = toCurrency(rate * qty)
            this.fixAll(false)
        },
        updateTotal() {
            let total = math.round(resolveNumericText(this.total), 2)
            let rate = math.round(resolveNumericText(this.rate), 2)
            this.qty = math.round(resolveNumericText(total / rate), 3)
            this.fixAll(false)
        },
        updateQty() {
            let rate = math.round(resolveNumericText(this.rate), 2)
            let qty = math.round(resolveNumericText(this.qty), 3)
            this.total = toCurrency(rate * qty)
            this.fixAll(false)
        },
        fixAll(changed = true) {
            if (changed) {
                this.rate = toCurrency(math.round(resolveNumericText(this.rate), 2));
                this.total = toCurrency(math.round(resolveNumericText(this.total), 2));
                this.qty = math.round(resolveNumericText(this.qty), 3)
            }
            this.material.rate = this.rate
            this.material.total = this.total
            this.material.qty = this.qty
            this.material.name = this.name
            this.material.uom = this.uom
            this.$emit('change')
        },
    },
    mounted() {
        this.fixAll();
    }
}
</script>
